import React, { useState } from 'react'
import { Button } from 'evergreen-ui'
import { MdPayments } from 'react-icons/md'
import { AllowPay } from '../../../Components/AllowPermission'
import PaymentDialog from '../../../Components/PaymentDialog'


const StatusManageRegist_0 = ({ DataRegister }) => {
    const [ModalPay, setModalPay] = useState(false);
    return (
        <>
        {
            DataRegister[0].ROB_ID !== "182"  ? (
                <>

                <Button
                onClick={() => {
                    localStorage.setItem("TERMPAY", "1/" + DataRegister[0].ROB_YEAR);
                    localStorage.setItem("FNAME", DataRegister[0].FULLNAME.split(" ")[0]);
                    localStorage.setItem("LNAME", DataRegister[0].FULLNAME.split(" ")[1]);
                    localStorage.setItem("ID_NO", DataRegister[0].REGISTER_ID);
                    localStorage.setItem("STOPDATE", DataRegister[0].ROB_CLOSE);
                    localStorage.setItem("AMOUNT", DataRegister[0].ROB_MONEY);
                    setModalPay(true);
                }}
                // disabled={AllowPay(DataRegister[0].ROB_CLOSE)}
                disabled={AllowPay(DataRegister[0].ROB_CLOSE)}
                iconBefore={<MdPayments />}
                appearance="primary"
                intent="success"
            >
                ชำระเงินค่าสมัคร
            </Button>


            <PaymentDialog
                isOpen={ModalPay}
                onClose={() => setModalPay(false)}
            />
</>
            ) : (<></>)
        }
            
        </>
    )
}

export default StatusManageRegist_0